import React, { FC, useState } from 'react';
import { LandscapeAboutContactPersonAddTemplate } from '../../templates';
import { useNavigate, useParams } from 'react-router-dom';
import { getUUID } from '../../../utils/UUID';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';
import { LandscapeContactPersonSaveRequestDto } from '../../../store/landscapeAPI/landscape/dto/request/landscape-contact-person-save-request.dto';
import {
  fetchLandscapeContactPersonByLandscapeId,
  saveLandscapeContactPerson,
} from '../../../store/landscapeAPI/landscape/reducers/landscape-contact-person.slice';
import { EntityType } from '../../../store/landscapeAPI/landscape/entity-type';
import Spinner from '../../atoms/Spinner/Spinner';

interface LandscapeAboutContactPersonAddPageProps {}

const LandscapeAboutContactPersonAddPage: FC<
  LandscapeAboutContactPersonAddPageProps
> = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [contactPerson, setContactPerson] =
    useState<LandscapeContactPersonResponseDto>({
      name: '',
      role: '',
      emailAddress: '',
      compactId: id ?? '',
      entityId: id ?? '',
      entityType: EntityType.Compact,
      id: getUUID(),
      versionId: 0,
      createdByUserId: '',
      createdOnDateTimeUtc: '',
      language: '',
      published: true,
    });

  const { status } = useSelector(
    (state: RootState) => state.landscapeContactPersonSlice
  );

  const handleOnChange = (contactPerson: LandscapeContactPersonResponseDto) => {
    setContactPerson(contactPerson);
  };

  const handleCancel = () => {
    navigate(`/landscapes/edit/${id}/about/contact-person`);
  };

  const callbackFn = async (
    contactPerson: LandscapeContactPersonResponseDto
  ) => {
    const contactPersonToSave: LandscapeContactPersonSaveRequestDto = {
      name: contactPerson.name,
      role: contactPerson.role,
      emailAddress: contactPerson.emailAddress,
      compactId: contactPerson.compactId,
      entityId: contactPerson.entityId,
      entityType: contactPerson.entityType,
      id: contactPerson.id,
      published: contactPerson.published,
    };
    await dispatch(saveLandscapeContactPerson(contactPersonToSave));
    if (id) {
      dispatch(fetchLandscapeContactPersonByLandscapeId(id));
    }
    navigate(`/landscapes/edit/${id}/about/contact-person`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeAboutContactPersonAddTemplate
      handleOnChange={handleOnChange}
      contactPerson={contactPerson}
      callbackFn={callbackFn}
      handleCancel={handleCancel}
    />
  );
};

export default LandscapeAboutContactPersonAddPage;
